<template>
    <div style="display: flex;gap: 3px;align-items: center;height: 60px;">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item v-for="(item,index) in aText">{{ item }}</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="annotation">
            <span v-if="docLink"
                  style="margin-left: 10px;color: #79bbff;display: flex;align-items: center;cursor: pointer;"
                  @click="goDocument">
            <el-button :icon="QuestionFilled" type="primary" plain>{{$t('public.systemOperationDocument')}}</el-button>
            </span>
        </div>
    </div>
</template>

<script setup>
import {QuestionFilled} from "@element-plus/icons-vue";

const props = defineProps({
    aText: Array,
    docLink: String
})
const goDocument = () => {
    window.open(props.docLink, '_blank');
}
</script>

<style scoped lang="less">
.annotation {
    margin-top: 3px;
    margin-left: 8px;
    font-size: 12px;
    color: #999999;
    display: flex;
    align-items: center;

    i {
        font-size: 14px;
    }

    .aText {
        margin-left: 3px;
    }
}

.el-divider--vertical {
    margin: 0 5px !important;
}
</style>
